import AutoNumeric from "autonumeric";
import "../../../../stylesheets/events";
import "../../../../stylesheets/templates/events/template-1";
import "../../../../stylesheets/accounts/base";
import "./index";
import { validateEmail } from "../../utils";
import { manageProductsCurrencies } from "./products";
import { validateTaxId, formatTaxIdInput } from "../../../utils";

const EMAIL_REGEXP = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

let subscriberDiscount = null;
let promoDiscount = null;
let activeDiscount = null;
let activeDiscountSource = null;
let subscriberBeatPromoNotified = false;

const getCheckDiscountUrl = () => $("#new_donator").data("checkDiscountUrl");
const getCheckPromoUrl = () => $("#new_donator").data("checkPromoUrl");
const getAccountName = () => $("#new_donator").data("accountName") || "";

const getInscriptionName = () => {
  const nameField = document.querySelector('input[name="inscription[0][Nombre]"]');
  return nameField?.value?.trim() || "";
};

const buildSubscriberBeatPromoMessage = () => {
  const name = getInscriptionName();
  const foundation = getAccountName();
  const greeting = name ? `Estimado ${name}` : "Estimado";

  return `${greeting}, al ser socio de ${foundation} tienes un descuento superior al del código ingresado. ¡Saludos!`;
};

const showSubscriberBeatPromoModal = () => {
  const body = document.getElementById("subscriber-discount-modal-body");
  if (body) {
    body.textContent = buildSubscriberBeatPromoMessage();
  }
  $("#subscriber-discount-modal").modal("show");
};

const getCurrentProductId = () =>
  $("#donator_donation_transactions_attributes_0_product_id")[0]?.value;

const getCurrencyType = () => $("#currency-type")[0]?.value;

const isValidEmail = (email) => EMAIL_REGEXP.test(email);

const formatCurrency = (amount, currencyType) =>
  new Intl.NumberFormat("es-CL", {
    currency: currencyType === "usd" ? "USD" : "CLP",
    style: "currency",
    minimumFractionDigits: currencyType === "usd" ? 2 : 0,
    maximumFractionDigits: currencyType === "usd" ? 2 : 0,
  }).format(amount);

const calculateDiscountAmounts = (originalTotal, discount, currencyType) => {
  const original = parseFloat(originalTotal);
  if (!discount) {
    return { original, discountAmount: 0, final: original };
  }

  const discountValue = parseFloat(discount.value);
  let discountAmount = 0;

  if (discount.type === "percentage") {
    discountAmount = (original * discountValue) / 100;
  } else if (discount.type === "amount" && currencyType !== "usd") {
    discountAmount = Math.min(discountValue, original);
  }

  return {
    original,
    discountAmount,
    final: Math.max(original - discountAmount, 0),
  };
};

const setDiscountIdField = (discount) => {
  const idField = document.getElementById("discount-id-field");
  if (!idField) return;

  idField.value = discount?.id ?? "";
};

const setPromoCodeField = (code) => {
  const promoField = document.getElementById("promo-code-field");
  if (!promoField) return;

  promoField.value = code ?? "";
};

const discountLabel = (discount, source) => {
  if (!discount) return "Descuento";

  if (source === "subscription") {
    return discount.type === "percentage"
      ? `Descuento suscriptor (${discount.value}%)`
      : "Descuento suscriptor";
  }

  if (discount.type === "percentage") {
    return `Código ${discount.code} (${discount.value}%)`;
  }

  return `Código ${discount.code}`;
};

const setDiscountCodeFeedback = (message, type = null) => {
  const feedback = document.getElementById("discount-code-feedback");
  if (!feedback) return;

  feedback.textContent = message || "";
  feedback.classList.toggle("d-none", !message);
  feedback.classList.toggle("is-error", type === "error");
  feedback.classList.toggle("is-success", type === "success");
};

const pickBestDiscount = (originalTotal, currencyType) => {
  const candidates = [];

  if (subscriberDiscount) {
    candidates.push({ source: "subscription", discount: subscriberDiscount });
  }

  if (promoDiscount) {
    candidates.push({ source: "general", discount: promoDiscount });
  }

  if (candidates.length === 0) {
    activeDiscount = null;
    activeDiscountSource = null;
    return null;
  }

  const best = candidates.reduce((currentBest, candidate) => {
    const candidateAmounts = calculateDiscountAmounts(
      originalTotal,
      candidate.discount,
      currencyType
    );
    const bestAmounts = calculateDiscountAmounts(
      originalTotal,
      currentBest.discount,
      currencyType
    );

    if (candidateAmounts.final < bestAmounts.final) return candidate;
    if (candidateAmounts.final > bestAmounts.final) return currentBest;

    return candidate.source === "subscription" ? candidate : currentBest;
  });

  activeDiscount = best.discount;
  activeDiscountSource = best.source;
  return best.discount;
};

const updatePriceSummaryUI = (amounts, currencyType) => {
  document.querySelectorAll("#event-price-subtotal").forEach(el => {
    el.textContent = formatCurrency(amounts.original, currencyType);
  });

  if (activeDiscount && amounts.discountAmount > 0) {
    const label = discountLabel(activeDiscount, activeDiscountSource);
    document.querySelectorAll("#event-price-discount-row").forEach(el => el.classList.remove("d-none"));
    document.querySelectorAll("#event-price-discount-label").forEach(el => { el.textContent = label; });
    document.querySelectorAll("#event-price-discount").forEach(el => {
      el.textContent = `-${formatCurrency(amounts.discountAmount, currencyType)}`;
    });
  } else {
    document.querySelectorAll("#event-price-discount-row").forEach(el => el.classList.add("d-none"));
  }

  document.querySelectorAll("#event-price-final").forEach(el => {
    el.textContent = formatCurrency(amounts.final, currencyType);
  });
};

const checkSubscriberDiscount = async (email, index) => {
  if (!window.eventDiscountEnabled || String(index) !== "0") return;

  const checkDiscountUrl = getCheckDiscountUrl();
  const productId = getCurrentProductId();
  if (!checkDiscountUrl || !productId || !isValidEmail(email)) {
    subscriberDiscount = null;
    calculateAmount();
    return;
  }

  const params = new URLSearchParams({ email, product_id: productId });

  try {
    const response = await fetch(`${checkDiscountUrl}?${params.toString()}`);
    const data = await response.json();
    subscriberDiscount = data.eligible ? data.discount : null;
    calculateAmount();
  } catch (error) {
    console.warn("[subscriber-discount]", { index, email, error });
    subscriberDiscount = null;
    calculateAmount();
  }
};

const checkPromoCode = async (code) => {
  const trimmedCode = code.trim();
  const checkPromoUrl = getCheckPromoUrl();
  const productId = getCurrentProductId();
  const currencyType = getCurrencyType();

  if (!checkPromoUrl || !productId) return;

  if (!trimmedCode) {
    promoDiscount = null;
    setPromoCodeField("");
    setDiscountCodeFeedback("");
    subscriberBeatPromoNotified = false;
    calculateAmount();
    return;
  }

  const params = new URLSearchParams({
    code: trimmedCode,
    product_id: productId,
    currency: currencyType,
  });

  try {
    const response = await fetch(`${checkPromoUrl}?${params.toString()}`);
    const data = await response.json();

    if (data.eligible) {
      promoDiscount = data.discount;
      setPromoCodeField(trimmedCode);
      calculateAmount();

      if (activeDiscountSource === "subscription") {
        setDiscountCodeFeedback("");
        if (!subscriberBeatPromoNotified) {
          subscriberBeatPromoNotified = true;
          showSubscriberBeatPromoModal();
        }
      } else {
        setDiscountCodeFeedback("Código aplicado", "success");
      }
    } else {
      promoDiscount = null;
      setPromoCodeField("");
      setDiscountCodeFeedback("Código inválido o no disponible", "error");
      calculateAmount();
    }
  } catch (error) {
    console.warn("[promo-code]", { code: trimmedCode, error });
    promoDiscount = null;
    setPromoCodeField("");
    setDiscountCodeFeedback("No se pudo validar el código", "error");
    calculateAmount();
  }
};

const checkPrimaryInscriptionEmail = () => {
  const emailField = document.getElementById("email-0");
  if (!emailField) return;

  const email = emailField.value.trim();
  if (email) {
    checkSubscriberDiscount(email, "0");
  } else {
    subscriberDiscount = null;
    calculateAmount();
  }
};

const checkCurrentPromoCode = () => {
  const discountInput = document.getElementById("discount-input");
  if (!discountInput) return;

  checkPromoCode(discountInput.value);
};

$(document).ready(function () {

  const initialProductId = $("#donator_donation_transactions_attributes_0_product_id")[0].value;
  if (initialProductId) {
    formFields(initialProductId);
  }
  calculateAmount();
  updateInscriptionWithHeaderClass();

  $(".event-inscriptions").on("input", ".email-field", function (e) {
    this.value = this.value.replaceAll(" ", "");
  });

  $(".addInscription").on("click", function (e) {
    let lastInscription = $(".event-inscriptions .row-inscription").length;
    e.preventDefault();
    const row = $(".event-inscriptions .row-inscription").prop("outerHTML");
    replaceInscriptionIndex(lastInscription, row, this.dataset["name"]);
    $(
      `.event-inscriptions .row-inscription[data-index="${lastInscription}"] .btn-delete`
    ).css("display", "block");
    $(
      `.event-inscriptions .row-inscription[data-index="${lastInscription - 1}"] .inscription-headers`
    ).css("display", "flex");
    $(
      `.event-inscriptions .row-inscription[data-index="${lastInscription}"] .inscription-headers`
    ).css("display", "flex");
    formatSelectFields();
    calculateAmount();
    updateInscriptionWithHeaderClass();
    $(".event-inscriptions")[0].scrollIntoView();
  });

  $(".event-inscriptions").on("click", ".btn-delete", function (e) {
    e.preventDefault();
    const index = $(this).data("index");
    if (!index) return;
    $(`.row-inscription[data-index="${index}"]`).remove();
    calculateAmount();
    updateInscriptionWithHeaderClass();
    checkPrimaryInscriptionEmail();
  });

  $(".event-inscriptions").on("blur", ".email-field", function () {
    const email = this.value.trim();
    const index = this.id.split("-").slice(-1)[0];
    checkSubscriberDiscount(email, index);
  });

  $(".event-inscriptions").on("input", ".email-field-input", function (e) {
    var id = this.id.split("-").slice(-1)[0];
    this.value = this.value.replaceAll(" ", "");
    validateEmail(`email-${id}`, `email-confirmation-${id}`);
  });

  $(".event-inscriptions").on("input", ".tax_id_input", function (e) {
    this.value = formatTaxIdInput(this.value, window.country_code);
  });

  $(".event-inscriptions").on("blur", ".tax_id_input", function (e) {
    const valid = validateTaxId(this.value, window.country_code);
    this.classList.toggle("is-invalid", !valid);
    this.classList.toggle("is-valid", valid);
  });

  $(".event-inscriptions").on("blur", ".tickets-quantity-input", function (e) {
    calculateAmount();
  });

  $("#discount-input").on("blur", function () {
    checkPromoCode(this.value);
  });

  $("#discount-input").on("input", function () {
    if (!this.value.trim()) {
      checkPromoCode("");
    }
  });

  // Currency selector
  $(".currency-selection label").click(({ target }) => {
    $("#currency-type")[0].value = target.getAttribute("data-currency");
    calculateAmount();
    checkCurrentPromoCode();
  });

  $(".product-type-selector").on("change", function (e) {
    formFields(this.value);
    let new_product_price =
      document.querySelectorAll(`[name="product_price['${this.value}']"`)[0]
        ?.value || "0";
    let new_product_price_usd =
      document.querySelectorAll(`[name="product_price_usd['${this.value}']"`)[0]
        ?.value || "0";
    $("#original-event-price")[0].value = new_product_price;
    $("#original-event-price-usd")[0].value = new_product_price_usd;
    $("#donator_donation_transactions_attributes_0_product_id")[0].value =
      this.value;
    manageProductsCurrencies(new_product_price, new_product_price_usd);
    calculateAmount();
    checkPrimaryInscriptionEmail();
    checkCurrentPromoCode();
  });
});

const updateInscriptionWithHeaderClass = () => {
  const container = document.querySelector(".event-inscriptions");
  if (!container) return;
  const rowCount = container.querySelectorAll(".row-inscription").length;
  container.classList.toggle("inscription-with-header", rowCount > 1);
};

const replaceInscriptionIndex = (index, row, inscription_name) => {
  $(".event-inscriptions").append(
    row
      .replaceAll('data-index="0"', `data-index="${index}"`)
      .replaceAll("[0]", `[${index}]`)
      .replaceAll(`${inscription_name} 1`, `${inscription_name} ${index + 1}`)
      .replaceAll("email-0", `email-${index}`)
      .replaceAll("email-confirmation-0", `email-confirmation-${index}`)
      .replaceAll("is-valid", "")
      .replaceAll("is-invalid", "")
      .replaceAll("inscription_0", `inscription_${index}`)
  );
};

const formatSelectFields = () => {
  $(".select2-field")?.select2();
  $(".select2-container").each(function () {
    if ($(this).next().hasClass("select2-container")) {
      $(this).next().remove();
    }
  });
};

const calculateAmount = () => {
  const currencyType = getCurrencyType();
  let product_price =
    currencyType == "usd"
      ? $("#original-event-price-usd")[0].value
      : $("#original-event-price")[0].value;
  let total_inscriptions = 0;
  let inscriptions_input = $(".event-inscriptions .tickets-quantity-input");
  for (var i = 0; i < inscriptions_input.length; i++) {
    total_inscriptions += parseInt(inscriptions_input[i].value);
  }
  const originalTotal = parseFloat(product_price) * total_inscriptions;
  const selectedDiscount = pickBestDiscount(originalTotal, currencyType);
  const amounts = calculateDiscountAmounts(
    originalTotal,
    selectedDiscount,
    currencyType
  );

  const amountInput = document.getElementById(
    "donator_donation_transactions_attributes_0_amount"
  );
  if (!amountInput) return;

  const an = AutoNumeric.getAutoNumericElement(amountInput);
  if (an) {
    an.set(amounts.final);
  } else {
    amountInput.value = amounts.final;
  }

  setDiscountIdField(
    selectedDiscount && amounts.discountAmount > 0 ? selectedDiscount : null
  );
  updatePriceSummaryUI(amounts, currencyType);

  document.querySelectorAll("#selected-product-amount").forEach(el => {
    el.textContent = total_inscriptions;
  });

  const totalButtonEl = document.getElementById("total_amount_product_desktop");
  if (totalButtonEl) {
    totalButtonEl.textContent = formatCurrency(amounts.final, currencyType);
  }

  const selectElement = document.getElementById("inscription_type_select");
  const productNameSpans = document.querySelectorAll("#selected-product-name");
  if (selectElement && productNameSpans.length > 0) {
    const updateProductName = () => {
      const selectedOptionText =
        selectElement.options[selectElement.selectedIndex].text;
      const name = selectedOptionText === "Seleccionar una opción" ? "" : selectedOptionText;
      productNameSpans.forEach(el => { el.textContent = name; });
    };
    updateProductName();
    selectElement.addEventListener("change", updateProductName);
  }
};

const formFields = (product_id) => {
  const noProductFields = document.querySelectorAll(
    `[data-product]:not([data-product="${product_id}"]):not([data-product=""])`
  );
  for (var i = 0; i < noProductFields.length; i++) {
    noProductFields[i].required = false;
    noProductFields[
      i
    ].parentElement.parentElement.parentElement.classList.add("d-none");
    noProductFields[
      i
    ].parentElement.parentElement.parentElement.classList.remove("d-flex");
  }
  const productFields = document.querySelectorAll(
    `[data-product="${product_id}"]`
  );
  for (var i = 0; i < productFields.length; i++) {
    productFields[i].required = productFields[i].dataset["req"] === "true";
    productFields[i].parentElement.parentElement.parentElement.classList.add(
      "d-flex"
    );
    productFields[
      i
    ].parentElement.parentElement.parentElement.classList.remove("d-none");
  }
};
